module.exports = __webpack_public_path__ + "img/mlk linda pg 2.4889a623.jpg";